import CONFIG from '@/config'

export default {
  storeUser: {},
  storeMch: {
    mchNo: CONFIG.MCH_NO || ''
  }
}



// WEBPACK FOOTER //
// ./src/store/default.js